import { render } from "./TextAncor.vue?vue&type=template&id=15006134&ts=true"
import script from "./TextAncor.vue?vue&type=script&lang=ts"
export * from "./TextAncor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__